{
    "GenericModal_PromptMessage": "Weet u zeker dat u dit venster wilt sluiten? Alle gewijzigde configuraties gaan verloren wanneer u het sluit.",
    "GenericModal_PromptConfirm": "Ja",
    "GenericModal_PromptCancel": "Annuleren",
    "NAME": "GenericModal"
}